/* global axios */
import ApiClient from './ApiClient';

class EvolutionAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  status(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_status`);
  }

  qr(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_qr`);
  }

  reconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution_reconnect`);
  }

  disconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution_disconnect`);
  }
}

export default new EvolutionAPI();
